module.exports = __webpack_public_path__ + "static/media/background.a39bd291.jpg";